import vMenu from '@/common/sideBar/index.vue' //侧边栏
import Popup from '@/components/popup/index.vue'
import {dataSource} from "@/api/api";

export default {
    props: {},
    name: 'home',
    components: { //注册组件
        vMenu, //侧边栏
        Popup
    },
    data() {
        return {
            baseInfoItemShow: true,
            informationAuthenticationShow: 3,
            baseFrom: {
                authInfo: {
                    state: '1'
                },
                countInfo: {
                    totalInvestment: '',
                    dockCompanySize: '',
                    publishSize: '',
                    collectedInfo: ''
                },
                projects: {
                    id: '',
                    financeId: '',
                    browseCount: '',
                    collectionCount: '',
                    financeAmount: '',
                    guaranteeType: '',
                    publishDate: '',
                    dockingInsCount: '',
                    creditAmount: '',
                    financingProgress: 60,
                    state: '',
                    value: false,
                },
                userInfo: {
                    name: '',
                    loginTime: '',
                    phone: ''
                },
            },
            show: false, //控制重置密码
            show1: false, //控制修改手机号
            title: '发送短信', //按钮描述
            steps: '1', //步骤
            phoneName: '', //手机号
            userData: [{
                id: '1',
                name: '验证码',
                type: 'code',
                value: '',
                msg: '',
                placeholder: '请输入验证码',
                info: '验证码不能为空',
                required: true,
            },
                {
                    id: '2',
                    name: '新密码',
                    type: 'password',
                    value: '',
                    msg: '',
                    placeholder: '请输入新密码',
                    info: '新密码不能为空',
                    required: true,
                },
                {
                    id: '3',
                    name: '重复新密码',
                    type: 'password',
                    value: '',
                    msg: '',
                    placeholder: '请重复新密码',
                    info: '重复新密码不能为空',
                    required: true,
                },
            ],
            resetPwData: { //重置密码-获取验证码
                activeCode: false,
                btnTitle: '',
                num: '60',
                iTimer: '',
            },
            phoneCode1: { //验证安全手机
                activeCode: false,
                btnTitle: '',
                num: '60',
                iTimer: '',
            },
            phoneCode2: { //验证安全手机-新的验证码
                activeCode: false,
                btnTitle: '获取验证码',
                num: '60',
                iTimer: '',
            },
            userData1: [ //修改手机号-获取验证码
                {
                    id: '1',
                    name: '验证码',
                    type: 'code',
                    value: '',
                    msg: '',
                    placeholder: '请输入验证码',
                    info: '验证码不能为空',
                    required: true,
                },
                {
                    id: '2',
                    name: '手机号',
                    type: 'phone',
                    value: '',
                    msg: '',
                    placeholder: '请输入新绑定手机号',
                    info: '新绑定手机号不能为空',
                    required: true,
                },
                {
                    id: '3',
                    name: '验证码',
                    type: 'code',
                    value: '',
                    msg: '',
                    placeholder: '请输入验证码',
                    info: '验证码不能为空',
                    required: true,
                },
            ],
            close: false, //控制关闭按钮

        };
    },
    computed: {
        checkData() { //校验-重置密码
            return this.userData.every(item => {
                if (item.msg) {
                    return false;
                } else {
                    return true;
                }
            })
        },

        updateCompanyName() { //企业名称
            return this.$store.state.userInfo.username;
        },
        updateTime() {
            return this.$store.state.userInfo.updateTime;
        }
    },
    methods: {
        //获取页面高度
        getHeightFn() {
            let content = document.getElementById('content').offsetHeight;
            let nav = document.getElementById('nav');
            nav.style.height = content + "px";
        },
        //全部融资
        allApply() {
            this.$router.push({
                name: "applyManage"
            })
        },
        //企业主页 正在进行中的融资
        postFinanceApplyFn() {
            dataSource.postFinanceApply().then(res => {
                let data = res.data.data;
                if (res.data.msg == "暂无数据") {
                    this.baseInfoItemShow = false;
                } else {
                    this.baseFrom.projects.id = data.id;
                    this.baseFrom.projects.financeId = data.financeId;
                    this.baseFrom.projects.browseCount = data.browseCount;
                    this.baseFrom.projects.collectionCount = data.collectionCount;
                    this.baseFrom.projects.financeAmount = data.financeAmount;
                    this.baseFrom.projects.guaranteeType = data.guaranteeType;
                    this.baseFrom.projects.createTime = data.createTime ? data.createTime.substring(0, 10) : "";
                    this.baseFrom.projects.dockingInsCount = data.dockingInsCount ? data.dockingInsCount : 0;
                    this.baseFrom.projects.creditAmount = data.creditAmount ? data.creditAmount : 0;
                    if (data.financingProgress == null) {
                        this.baseFrom.projects.financingProgress = 0;
                    } else {
                        this.baseFrom.projects.financingProgress = data.financingProgress;
                    }
                    this.baseFrom.projects.state = data.status;

                    if (data.isShow == 1) {
                        this.baseFrom.projects.value = true
                    } else {
                        this.baseFrom.projects.value = false
                    }
                }
            }).catch(err => {

            })
        },
        changeShow(val, id) { //是否展示到项目大厅
            if (val) {
                val = 1;
            } else {
                val = 0;
            }
            dataSource.postCompanyProductIsShow({
                id: id,
                isShow: val
            }).then(res => {
                if (res.data.data) {
                    this.postFinanceApplyFn();
                    this.$message.success(res.data.msg)
                } else {
                    this.$message.error(res.data.msg)
                }
            }).catch(err => {

            })
        },
        //进行中的融资查看详情
        goApplyManage(id) {
            sessionStorage.setItem("productId", id);
            this.$router.push({
                name: 'applyManageInfo',
            })
        },
        accountManage() { //账号管理
            this.$router.push({
                name: "accountManage"
            })
        },
        //企业主页 数据统计
        postStatisticsFn() {
            dataSource.postStatistics().then(res => {
                let data = res.data.data;
                this.baseFrom.countInfo.totalInvestment = data.rzze;
                this.baseFrom.countInfo.publishSize = data.yfbsqs;
                this.baseFrom.countInfo.dockCompanySize = data.djjg;
                this.baseFrom.countInfo.collectedInfo = data.scxxs;
            }).catch(err => {

            })
        },
        //企业主页 认证状态
        getAuthInfoFn() {
            dataSource.getAuthInfo().then(res => {
                let data = res.data.data;
                //console.log(data)
                this.baseFrom.userInfo.name = data.companyName ? data.companyName : data.phone;

                localStorage.setItem("companyName", data.companyName ? data.companyName : data.phone)
                this.$store.commit('updataCompanyName', data.companyName ? data.companyName : data.phone);
                if (data.stepStatus == '3') {
                    this.baseFrom.authInfo.state = '3';
                    localStorage.setItem("stepStatus", true)
                } else {
                    this.baseFrom.authInfo.state = '1';
                    localStorage.setItem("stepStatus", false)
                }

            }).catch(err => {

            })
        },
        //去认证
        goAuthentication() {
            this.$router.push({
                name: "info"
            })
        },
        //获取企业信息
        postGetCompanyUserInfoFn() {
            dataSource.postGetCompanyUserInfo().then(res => {
                let data = res.data.data;
                this.baseFrom.userInfo.phone = data.userName;
                this.baseFrom.userInfo.loginTime = data.updateTime;
                localStorage.setItem("entId", data.id);
                localStorage.setItem("phone", data.userName);
            }).catch(err => {

            })
        },

    },
    created() {

    },
    mounted() {

        this.postFinanceApplyFn();
        this.postStatisticsFn();
        this.getAuthInfoFn();
        this.postGetCompanyUserInfoFn();
        this.getHeightFn();

    },

}
